<div class="row modal-bar">

    <div class="col-sm-6">
        <h5 class="modal-title">{{ passedData.title }}</h5>
    </div>

    <div class="col-sm-6">

        <div class="modal-actions">

            <div class="modal-close">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
            </div>
        </div>
    </div>
</div>

<t4-customer-search viewMode="minimal" (onCustomerSelect)="onCustomerSelect($event)"></t4-customer-search>